module.exports = __webpack_public_path__ + "img/1.845d290a.jpg";